<div
  [ngClass]="
    ['home'].includes(showFrom)
      ? 'p-3 mx-2 bg-secondary-subtle rounded text-dark'
      : ''
  "
>
  @if (["home"].includes(showFrom)) {
    <div class="d-flex align-items-center mb-4 mb-lg-3">
      <div class="fw-bold flex-grow-1" id="getStarted">Getting Started</div>
      <div (click)="showGuideOptions('hideGetStarted')">
        <i class="fa fa-close text-dark fs-4"></i>
      </div>
    </div>
  }
  <div
    id="gettingStartedTasks"
    class="d-flex"
    [ngClass]="
      ['home'].includes(showFrom)
        ? 'flex-column gap-3 row-gap-4 row-gap-lg-3'
        : 'gap-3 flex-wrap'
    "
  >
    @for (guide of guideOptions; track $index) {
      @if (guide?.showItem) {
        @if (["home"].includes(showFrom)) {
          <div
            class="d-flex gap-2 align-items-center py-2 border-secondary-subtle"
          >
            <div (click)="onTaskComplete(guide)" role="button">
              @if (guide?.is_completed) {
                <span>
                  <i
                    class="pe-none fs-4 fa-regular fa-square-check opacity-75"
                  ></i>
                </span>
              } @else {
                <span>
                  <i class="pe-none fs-4 fa-regular fa-square"></i>
                </span>
              }
            </div>
            <div
              [ngClass]="
                guide?.is_completed
                  ? 'text-decoration-line-through opacity-75'
                  : ''
              "
            >
              {{ guide?.header }}
            </div>
            @if (!guide?.is_completed) {
              <div
                (click)="guide.pressed(); $event.stopImmediatePropagation()"
                class="custom-button"
              >
                Show Me How
                <i
                  class="fa-solid fa-circle-info fs-5 ms-3 text-success d-none"
                ></i>
              </div>
            }
          </div>
        } @else {
          <div
            class="fw-semibold nav-link text-primary hover"
            (click)="guide.pressed(); $event.stopImmediatePropagation()"
          >
            {{ guide?.header }}
          </div>
        }
      }
    }
    @if (
      (isAdmin || isDispatchUser) && !largeView && ["home"].includes(showFrom)
    ) {
      <div>
        <p>Remember, Guard Tracker works on desktop and laptop, too.</p>
      </div>
    }
  </div>
</div>
